import { TApplicationState } from 'shared/types/redux';

export function authorizedSelector(state: TApplicationState): boolean {
  return state.auth.authorized;
}
